import React from 'react';
import NumberFormat from 'react-number-format';
import { onChange, validateForm } from './../../utils';
import uniqid from 'uniqid';


class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const detail = props.detail;
        this.state = {
            id: detail ? detail.id : '',
            uid: detail ? detail.uid : uniqid(),
            depStation: { name: 'depStation', value: '', error: '', options: props.loc, isRequired: true },
            depDate: { name: 'depDate', value: '', error: '', isRequired: true },
            depTime: { name: 'depTime', value: '', error: '', isRequired: true },

            arrStation: { name: 'arrStation', value: '', error: '', options: props.loc, isRequired: true },
            arrDate: { name: 'arrDate', value: '', error: '', isRequired: true },
            arrTime: { name: 'arrTime', value: '', error: '', isRequired: true },

            modeOfJourney: { name: 'modeOfJourney', value: '', error: '', isRequired: true },
            fareClass: { name: 'fareClass', value: '', error: '', isRequired: true },
            noOfFare: { name: 'noOfFare', value: '', error: '', isRequired: true },
            amount: { name: 'amount', value: '', error: '', isRequired: true },
            // bills: { name: 'bills', value: [], error: '', isRequired: false },
        }
    }

    render() {
        const { depStation, depDate, depTime, arrStation, arrDate, arrTime, modeOfJourney, fareClass, noOfFare, amount } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Departure station <small>*</small></label>
                                        <select
                                            className={depStation.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            name={depStation.name}
                                            value={depStation.value}
                                            onChange={this.onChange}
                                        >
                                            <option>Select a location</option>
                                            {
                                                depStation.options.map(function (item: any, index: number) {
                                                    return (
                                                        <option key={index} value={item}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Departure date <small>*</small></label>
                                        <input
                                            type="date"
                                            className={depDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={depDate.name}
                                            value={depDate.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Departure time <small>*</small></label>
                                        <input
                                            type="time"
                                            className={depTime.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={depTime.name}
                                            value={depTime.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Arrival station <small>*</small></label>
                                        <select
                                            className={arrStation.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            name={arrStation.name}
                                            value={arrStation.value}
                                            onChange={this.onChange}
                                        >
                                            <option>Select a location</option>
                                            {
                                                arrStation.options.map(function (item: any, index: number) {
                                                    return (
                                                        <option key={index} value={item}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Arrival date <small>*</small></label>
                                        <input
                                            type="date"
                                            className={arrDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={arrDate.name}
                                            value={arrDate.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Arrival time <small>*</small></label>
                                        <input
                                            type="time"
                                            className={arrTime.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={arrTime.name}
                                            value={arrTime.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Mode of journey <small>*</small></label>
                                        <input
                                            type="text"
                                            className={modeOfJourney.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={modeOfJourney.name}
                                            value={modeOfJourney.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Fare class<small>*</small></label>
                                        <input
                                            type="text"
                                            className={fareClass.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={fareClass.name}
                                            value={fareClass.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>No. of fare <small>*</small></label>
                                        <NumberFormat
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            allowNegative={false}
                                            className={noOfFare.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={noOfFare.name}
                                            value={noOfFare.value}
                                            onValueChange={(e: any) => { this.onChange({ target: { name: noOfFare.name, value: e.value } }) }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Amount <small>*</small></label>
                                        <NumberFormat
                                            decimalScale={2}
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            className={amount.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={amount.name}
                                            value={amount.value}
                                            onValueChange={(e: any) => { this.onChange({ target: { name: amount.name, value: e.value } }) }}
                                        />
                                    </div>
                                </div>


                                {/* <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Bill(s) <sup>(optional)</sup></label>
                                        <input
                                            name={bills.name}
                                            onChange={this.onChange}
                                            type="file"
                                            multiple={true}
                                            className="form-control"
                                            style={{ padding: 4 }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        {
                                            Array.from(bills.value).map(function (item: any, index: number) {
                                                return (
                                                    <span key={index} className="badge badge-primary mr-1">{item.name}</span>
                                                )
                                            })
                                        }
                                    </div>
                                </div> */}

                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.onCancel} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                                </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }
    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const st = this.state;
            const model = {
                id: st.id,
                uid: st.uid,
                depStation: st.depStation.value,
                depDate: st.depDate.value,
                depTime: st.depTime.value,

                arrStation: st.arrStation.value,
                arrDate: st.arrDate.value,
                arrTime: st.arrTime.value,

                modeOfJourney: st.modeOfJourney.value,

                fareClass: st.fareClass.value,
                noOfFare: parseFloat(st.noOfFare.value),
                amount: parseFloat(st.amount.value),
                // bills: st.bills.value
            };
            if (st.id === "") {
                model.id = new Date().getTime();
            }
            this.props.onSubmit(model);
        }
    }
}

export default ComponentName;